export default __webpack_public_path__ + "static/media/icon-calendar.5cd92221.svg";